(function () {
  const syncInputs = function (checkbox) {
    const container = checkbox.closest('.form-check');
    if (!container) return;
    container.querySelectorAll('input[type="hidden"]').forEach((input) => {
      input.disabled = !checkbox.checked;
    });
  };

  const bindBuckets = function (root) {
    root.querySelectorAll('input[type="checkbox"].price-bucket:not([data-bound])').forEach((checkbox) => {
      checkbox.dataset.bound = 'true';
      checkbox.addEventListener('change', function () {
        if (checkbox.checked) {
          const group = checkbox.closest('.js-filter');
          if (group) {
            group.querySelectorAll('.price-bucket').forEach((other) => {
              if (other !== checkbox) {
                other.checked = false;
                syncInputs(other);
              }
            });
          }
        }
        syncInputs(checkbox);
      });
    });
  };

  // Restores checked/enabled state on filter inputs after any re-render
  // (AJAX outerHTML swap wipes DOM state since the static Liquid fallback
  // has no active-state logic — see facets.liquid:486-521).
  const restoreActiveStates = function (root) {
    const params = new URLSearchParams(window.location.search);

    // 1. Price buckets — match this bucket's hidden gte/lte inputs against the URL
    root.querySelectorAll('input[type="checkbox"].price-bucket').forEach((checkbox) => {
      const container = checkbox.closest('.form-check');
      if (!container) return;

      const hiddenInputs = container.querySelectorAll('input[type="hidden"]');
      if (hiddenInputs.length === 0) return;

      // A bucket is "active" only if every one of its hidden inputs
      // (gte, and lte if present) matches the current URL value exactly.
      // Bucket 4 (open-ended, e.g. "4000+") has gte only — no lte to check.
      let isActive = true;
      hiddenInputs.forEach((input) => {
        const urlValue = params.get(input.name);
        if (urlValue === null || urlValue !== input.value) {
          isActive = false;
        }
      });

      checkbox.checked = isActive;
      syncInputs(checkbox);
    });
  };

  const init = function () {
    const form = document.getElementById('FacetFiltersForm');
    if (!form) return;
    bindBuckets(form);
    restoreActiveStates(form);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  const form = document.getElementById('FacetFiltersForm');
  if (form && typeof MutationObserver !== 'undefined') {
    new MutationObserver(init).observe(form, { childList: true, subtree: true });
  }
})();